import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface EloPointsAnimationProps {
  points: number;
  show: boolean;
}

const EloPointsAnimation: React.FC<EloPointsAnimationProps> = ({ points, show }) => {
  const isPositive = points > 0;
  
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 20, scale: 0.5 }}
          animate={{ 
            opacity: 1, 
            y: -50,
            scale: [1, 1.2, 1],
            rotate: [-10, 10, -10, 0],
          }}
          exit={{ opacity: 0, y: -100 }}
          transition={{ 
            duration: 1.5,
            rotate: {
              duration: 0.5,
              repeat: 0
            }
          }}
          className="fixed top-24 right-4 z-50 pointer-events-none"
        >
          <div className={`font-bold text-3xl ${isPositive ? 'text-green-500' : 'text-red-500'}`}>
            {isPositive ? '+' : ''}{points} ELO
            <span className="ml-2 text-4xl">{isPositive ? '🚀' : '📉'}</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default EloPointsAnimation;